import { CartItemDetails } from '../data/store-data';
import { Environments, ICheckoutState, PaymentOptions } from '../store/CheckoutContext';

export const getApiKeys = () => {
  let siteId = '';
  let mid = '';
  let appKey = '';
  let appSecret = '';
  let spreedlyKey = '';
  // @ts-ignore
  if (
    // @ts-ignore
    typeof window?.Cypress === 'undefined' &&
    // @ts-ignore
    typeof window?.top?.Cypress === 'undefined' &&
    window?.top?.location?.search
  ) {
    window?.top?.location?.search
      ?.replace('?', '')
      ?.split('&')
      ?.forEach(el => {
        if (el.includes('mid=')) {
          mid = el.replace('mid=', '');
        }

        if (el.includes('appKey=')) {
          appKey = el.replace('appKey=', '');
        }

        if (el.includes('appSecret=')) {
          appSecret = el.replace('appSecret=', '');
        }

        if (el.includes('spreedlyKey=')) {
          spreedlyKey = el.replace('spreedlyKey=', '');
        }
      });
  }

  if (siteId.length === 0) {
    siteId = localStorage.getItem('siteId') || '';
  }

  if (mid.length === 0) {
    mid = localStorage.getItem('mid') || '';
  }

  if (appKey.length === 0) {
    appKey = localStorage.getItem('appKey') || '';
  }

  if (appSecret.length === 0) {
    appSecret = localStorage.getItem('appSecret') || '';
  }

  if (spreedlyKey.length === 0) {
    spreedlyKey = localStorage.getItem('spreedlyKey') || '';
  }

  return {
    appKey,
    appSecret,
    spreedlyKey,
    mid,
    siteId,
  };
};

export const getPaymentBody = (
  state: ICheckoutState,
  cart: CartItemDetails[],
  environment: Environments,
  orderId: string,
  ip?: string,
) => {
  const body = {
    // @ts-ignore
    // SiteUrl: window?.Cypress !== 'undefined' ? 'http://localhost:3002/' : window?.top.location.origin,
    SiteUrl: window?.top.location.origin,
    OrderSource: state.sourceOptions,
    environment,
    isDeclined: true,
    mid: state?.mid,
    siteId: state?.siteId,
    appKey: state?.appKey,
    appSecret: state?.appSecret,
    spreedlyKey: state?.spreedlyKey,
    // mid: '9f0e0e29-cb0a-4455-ac3c-46f4c0a72516',
    OrderId: orderId,
    CustomerIp: ip,
    merchant: {
      name: 'Merchant name',
      id: state?.mid,
      mcc: state?.mcc || 701,
      country: 'USA',
    },
    externalOrderReference: new Date().getTime(),
    // senseKey: window.localStorage.getItem('senseKey'),
    idempotencyKey: state?.idempotencyKey || crypto.randomUUID(),
    isRecurring: state?.paymentOptions === PaymentOptions.mit,
    isMit: state?.paymentOptions === PaymentOptions.mit,
    transaction: {
      id: new Date().getTime(),
      processorName: 'smartpay',
      responseCode: state?.responseCode,
      transactionType: state?.transactionType || 'string',
      // responseStatus: state?.transactionStatus || 'string',
      // @ts-ignore
      amount: state?.transactionAmount ? (state?.transactionAmount * 100).toFixed(0) : 0,
      // amount: 444,
      currency: state?.currency || 'USD',
      externalReference: 'string',
      avsResultCode: state?.avsResultCode,
      cvvResultCode: state?.cvvResultCode,
      cavvResultCode: state?.cavvResultCode,
      responseStatus: 'string',
      externalTransactionId: '12345',
      responseCodeSource: state?.gatewaySource,
      status: state?.transactionStatus || '',
      timestampUtc: new Date().toUTCString(),
      timezoneUtcOffset: new Date().getTimezoneOffset(),
      cardNotPresent: true,
    },
    payee: {
      name: state?.payeeName || state?.billingFirstName,
      mcc: state?.mcc || 'string',
      type: state?.payeeType || 'string',
    },
    payer: {
      // firstName: state?.billingFirstName,
      // lastName: state?.billingLastName,
      email: state?.email,
      phone: state?.phone,
      // birthDate: '2002-05-10',
      // externalId: uuidv4(),
      id: state?.payerId ?? null,
    },
    paymentMethod: {
      cardType: state?.cardType || 'debit',
      cardBrand: 'VISA',
      holderName: state?.cardName,
      cardNumber: state?.cardNumber,
      cardCountry: state?.billingCountry,
      cardBinNumber: state?.cardNumber ? (state?.cardNumber as string)?.substring(0, 8) : '12345678',
      cardLast4Digits: state?.cardNumber
        ? (state?.cardNumber as string)?.substring((state?.cardNumber as string)?.length - 4)
        : '1525',
      expirationMonth: state?.expirationMonth,
      expirationYear: state?.expirationYear,
      type: 'string',
      // type: 'Prepaid',
      cvv: state?.cvv,
    },
    billingInformation: {
      countryCode: state?.countryCode || state?.billingCountry,
      country: state?.billingCountry,
      addressLine1: state?.billingAddressLine1,
      addressLine2: state?.billingAddressLine2 ?? null,
      zipcode: state?.billingZip,
      city: state?.billingCity,
      firstName: state?.billingFirstName,
      lastName: state?.billingLastName,
    },
    shippingInformation: null,
    orderItems: (cart || []).map((item, index) => ({
      sku: index,
      name: item.item.title || item.item.name,
      // description: item.item.description,
      description: 'string',
      amount: (item.item.price * 100).toFixed(0),
      discountAmount: 0,
      discountType: 'string',
      quantity: item.quantity,
    })),
  };

  if (state?.DynamicDescriptor) {
    // @ts-ignore
    body.transaction.DynamicDescriptor = state?.DynamicDescriptor;
  }

  if (state?.paymentOptions === PaymentOptions.mit) {
    const date = new Date();
    date.setDate(date.getDate() + 4);
    // @ts-ignore
    body.ExpiryDateUtc = date.toISOString();
  }

  if (!state?.withEvaluate) {
    // @ts-ignore
    body.transaction.withEvaluate = state?.withEvaluate;
  }

  return body;
};

export const getDemoKeys = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'sandbox':
      return {
        siteId: '1569d133-9622-4559-a00b-dbc555030a62',
        mid: '93bf3f71-8505-49dc-85e2-9a5fce6a014a',
        appKey: 'JU7VSy6SUdWGOH2SvLRWsnoaeBF9QvrtKOjWK8N9',
        appSecret: 'AQAAAAEAACcQAAAAEGssGzQ6QI9fMVH9fQghPWfymzpdTuthaHYe/xem5JB4IZH8mu8zR9Zpchfsndwhpw==',
        spreedlyKey: 'OOeydiWCG7ctam09vUjf1Ons8qM',
      };
    case 'local':
      return {
        siteId: '69e179fb-aa57-4b8a-9fed-3d5f8db4292a',
        mid: '76e105a7-4d60-457b-82f2-648d46aba287',
        appKey: 'V6ESFGpoKVhxKJGtYog0mjdxsRLZKEGv2BC+A+rg',
        appSecret: 'AQAAAAEAACcQAAAAEEjwdlh0dH/Vzp7sKyw2xytswc0ym2WZjzQpReWxBzAjgFZS+4/BfEThPBYJAUExqA==',

        spreedlyKey: 'KCODvqB8DgiAoNRmKu1dw8dmuJf',
      };
    case 'development':
    case 'staging':
    default:
      return {
        siteId: 'cc3d2402-1066-4008-b990-97cb66c0ffaf',
        mid: '76e105a7-4d60-457b-82f2-648d46aba287',
        appKey: 'U2+oQhWPfRQmdYfRv8KDNY2V8kaoNRHDhw6kD3/9',
        appSecret: 'AQAAAAEAACcQAAAAEEf2ksHBXCpwWl6dzRXazeud486zKX6SvPkCYcgLnd5yro3rDv+693Z6uBHbXxaV+w==',
        spreedlyKey: 'KCODvqB8DgiAoNRmKu1dw8dmuJf',
      };
  }
};

export const checkIfValidUUID = (value: string): boolean => {
  // Updated regex to validate both UUID v4 and v7
  const regexExp =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-(4[0-9a-fA-F]{3}|7[0-9a-fA-F]{3})-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

  return regexExp.test(value);
};
